var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { padding: "30px 40px 50px 40px" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Serie Devolución Bodega" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.devonumero.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.devonumero.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.devonumero,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.devonumero.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.devofecha_alta.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.devofecha_alta.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.devofecha_alta,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.devofecha_alta.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label:
                                    _vm.formFields.devofecha_recepcion.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value:
                                    _vm.formFields.devofecha_recepcion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.devofecha_recepcion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.devofecha_recepcion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.usuarioid.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.usuarioid.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.usuarioid,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.usuarioid.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.usuariorut.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.usuariorut.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.usuariorut,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.usuariorut.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.coorid.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.coorid.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.coorid,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.coorid.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.coorname.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.coorname.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.coorname,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.coorname.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "gridcard rounded-card" },
                        [
                          _c("MantenedorGrid", {
                            attrs: { "grid-options": _vm.gridOptions }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }